export function getRRegexDocs(version: string = 'latest') {
  return `https://tsdocs.dev/docs/rregex/${version}`
}

export function getRustRegexDocs(version: string = 'latest') {
  return `https://docs.rs/regex/${version}/regex/`
}

export function getRustRegexSyntaxDocs(version: string = 'latest') {
  return `https://docs.rs/regex-syntax/${version}/regex_syntax/`
}
